import React from 'react';
import { useTiclickTableContext } from './context/ticlick-table-context-hook';
import type { Table as TableT } from '@tanstack/react-table';
import { ViewSettings } from '@src/shared/features/views/components/view-settings';

export type ActionVisibility = 'none-selection' | 'selection' | 'common';

export interface ActionItemProps<T> {
  key: string;
  render: (table: TableT<T>) => React.ReactNode;
  minWidth?: number;
  visibility: ActionVisibility;
  isDisplay?: boolean;
}

export interface TableActionsProps<T> {
  actions: ActionItemProps<T>[];
}

export default function TiclickTableTableActions<T>({
  actions,
}: TableActionsProps<T>) {
  const { table } = useTiclickTableContext<T>();

  // Selected rows can live on other pages, so check the whole selection
  // rather than the current page's rows.
  const isSelectionMode = table.getSelectedRowModel().rows.length > 0;

  const visibleActions = actions.filter((action) => {
    return (
      action.visibility === 'common' ||
      (isSelectionMode
        ? action.visibility === 'selection'
        : action.visibility === 'none-selection')
    );
  });

  return (
    <div className='flex shrink-0 items-center justify-end gap-3'>
      {visibleActions
        .filter((action) => action.isDisplay !== false)
        .map((action) => {
          const node = action.render(table);
          if (node == null) return null;

          return (
            <div
              key={action.key}
              className='transition-transform duration-200 ease-in-out 
                   opacity-0 translate-y-2 scale-95 
                   data-[state=visible]:opacity-100 data-[state=visible]:translate-y-0 data-[state=visible]:scale-100'
              data-state='visible'
            >
              {node}
            </div>
          );
        })}

      <ViewSettings />
    </div>
  );
}
